import { Attributes, Validation, ValueObject } from '@singularsystems/neo-core';

export default class AddChildInterestRateTypeCommand extends ValueObject {

    constructor(
        parentInterestRateTypeId: number,
        isLinkedToInvestments: boolean,
        rateFrequencyName: string) {
        super();
        this.parentInterestRateTypeId = parentInterestRateTypeId;
        this.isLinkedToInvestments = isLinkedToInvestments;
        this.rateFrequencyName = rateFrequencyName;
        this.makeObservable();
    }

    public parentInterestRateTypeId: number;

    public isLinkedToInvestments: boolean;

    public rateFrequencyName: string;

    @Attributes.Integer()
    public dayOffset: number = 5;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AddChildInterestRateTypeCommand>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.dayOffset <= 0, "Day offset must be a positive integer.");
    }

    public toString(): string {
        return "Add Child Interest Rate Type Command";
    }
}